import { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@mui/material'

import {
  useAddressBookByCenter,
  useAddressBookSearch,
} from '../../../services/addressBook'
import DrawerWrapper from '../../../ui/modules/DrawerWrapper'
import AddressBookUI from '../../../ui/modules/AddressBook'
import { STEPS } from '../../../common/constants'
import FixedBottomWrapper from '../../../ui/components/FixedBottomWrapper'
import MobileFullScreenLayout from '../../../ui/layout/MobileFullScreen'

const ADDRESSES_PER_PAGE = 5
const ADDRESSES_INITIAL_PAGE = 0

const propTypes = {
  closeAgenda: PropTypes.func.isRequired,
  confirmDirection: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  centreCode: PropTypes.string,
  currentStep: PropTypes.string
}

function AddressBook({ closeAgenda, isOpen, centreCode, confirmDirection, currentStep }) {
  const [validOrigin, setValidOrigin] = useState(false)
  const [hasPhone, setHasPhone] = useState(false)
  const [selected, setSelected] = useState(null)

  const [pagination, updatePagination] = useState({
    limit: ADDRESSES_PER_PAGE,
    page: ADDRESSES_INITIAL_PAGE,
  })

  const [search, setSearch] = useState('')

  const addressesQuery = useAddressBookByCenter(
    {
      centreCode,
      pageLimit: pagination.limit,
      pageOffset: pagination.page,
    },
    { enabled: search === '' },
  )

  const addressesSearchQuery = useAddressBookSearch({
    centreCode,
    pageLimit: pagination.limit,
    pageOffset: pagination.page,
    searchFilterValue: search,
  })

  const query = search === '' ? addressesQuery : addressesSearchQuery
  const { data: addresses } = query?.data ?? []

  return (
    <>
      <DrawerWrapper
        isOpen={isOpen}
        anchor="bottom"
        onClose={() => closeAgenda()}
      >
        <MobileFullScreenLayout title="Agenda" onClose={() => closeAgenda()}>
          <AddressBookUI
            isOpen={isOpen}
            isLoading={query.isLoading}
            count={query?.data?.pagination?.totalCount}
            page={pagination.page}
            rowsPerPage={query?.data?.pagination?.itemsPerPage}
            addresses={addresses}
            hasPhone={hasPhone}
            validOrigin={validOrigin}
            selected={selected}
            onChange={address => {
              if(currentStep===STEPS.FROM)
                setValidOrigin(address.country==='ES' || address.country==='PT')
              else(setValidOrigin(true))
              if(!address.phone?.length)
                setHasPhone(false)
              else(setHasPhone(true))
              setSelected(address)
            }}
            onPageChange={(_event, page) => {
              updatePagination(pagination => ({ ...pagination, page }))
            }}
            onRowsPerPageChange={event => {
              const limit = event.target.value
              updatePagination({
                page: ADDRESSES_INITIAL_PAGE,
                limit,
              })
            }}
            onCancel={() => closeAgenda()}
            onAddSearchFilter={debouncedSearch => {
              setSearch(debouncedSearch)
            }}
            onSubmit={() => {}}
          ></AddressBookUI>
          <FixedBottomWrapper fullWidth>
            <Button
              fullWidth
              type="button"
              disabled={!Boolean(selected && validOrigin && hasPhone)}
              onClick={() => {
                confirmDirection(selected)
                closeAgenda()
              }}
              variant="contained"
            >
              Confirmar
            </Button>
          </FixedBottomWrapper>
        </MobileFullScreenLayout>
      </DrawerWrapper>
    </>
  )
}

AddressBook.propTypes = propTypes

export default AddressBook
